export const images = {
    logo: '/images/logo_transparent.webp',
    background: '/images/maplestory2.webp',
    completedStamp: '/images/completed_stamp.webp',
    bosses: {
        'Balrog': '/images/balrog.webp',
        'Zakum': '/images/zakum.webp',
        'Ursus': '/images/ursus.webp',
        'Magnus': '/images/magnus.webp',
        'Hilla': '/images/hilla.webp',
        'OMNI-CLN': '/images/omni-cln.webp',
        'Papulatus': '/images/papulatus.webp',
        'Pierre': '/images/pierre.webp',
        'Von Bon': '/images/von_bon.webp',
        'Crimson Queen': '/images/crimson_queen.webp',
        'Vellum': '/images/vellum.webp',
        'Von Leon': '/images/von_leon.webp',
        'Horntail': '/images/horntail.webp',
        'Arkarium': '/images/arkarium.webp',
        'Pink Bean': '/images/pink_bean.webp',
        'Gollux': '/images/gollux.webp',
        'Ranmaru': '/images/ranmaru.webp',
        'Julieta': '/images/julieta.webp',
        'Cygnus': '/images/cygnus.webp',
        'Lotus': '/images/lotus.webp',
        'Damien': '/images/damien.webp',
        'Lucid': '/images/lucid.webp',
        'Gloom': '/images/gloom.webp',
        'Verus Hilla': '/images/verus_hilla.webp',
        'Darknell': '/images/darknell.webp',
        'Will': '/images/will.webp',
        'Princess No': '/images/princess_no.webp'
    },
    quests: {
        'Commerci': '/images/commerci.webp',
        'Yu Garden': '/images/yu_garden.webp',
        'Vanishing Journey': '/images/vanishing_journey.webp',
        'Erda Spectrum': '/images/erda_spectrum.webp',
        'Chu Chu Island': '/images/chu_chu_island.webp',
        'Hungry Muto': '/images/hungry_muto.webp',
        'Lachelein': '/images/lachelein.webp',
        'Dream Defender': '/images/dream_defender.webp',
        'Arcana': '/images/arcana.webp',
        'Spirit Savior': '/images/spirit_savior.webp',
        'Morass': '/images/morass.webp',
        'Esfera': '/images/esfera.webp',
        'Tenebris': '/images/moonbridge.webp',
        'Monster Park': '/images/monster_park.webp',
        'Maple Tour': '/images/maple_tour.webp',
        'Legion': '/images/legion.webp',
        'Fairy Bros Gift': 'images/fairy_bros_gift.webp',
        'Reward Points': '/images/reward_points.webp',
        'MVP Reward': '/images/mvp_reward.webp',
        'Guild Gifts': '/images/guild_gifts.webp',
        'Mu Lung Dojo': '/images/mu_lung.webp',
        'Kritias': '/images/kritias.webp',
        'Haven': '/images/haven.webp',
        'Dark World Tree': '/images/dark_world_tree.webp'
    }
}
